import React from 'react';
import CompanyCard from './CompanyCard';
import { observer } from 'mobx-react';
// import { toJS } from 'mobx';
import Slider from 'react-slick';
import store from '../../../../stores/store';

const CompanyCarousel = observer(
    class CompanyCarousel extends React.Component {
        getSettings = lenght => {
            return {
                dots: lenght > 8,
                arrows: true,
                infinite: false,
                easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                speed: 600,
                draggable: false,
                vertical: false,
                slidesToShow: 8,
                slidesToScroll: 8,
                focusOnSelect: false,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            dots: lenght > 6,
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 1400,
                        settings: {
                            dots: lenght > 5,
                            slidesToShow: 5,
                            slidesToScroll: 5,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            dots: lenght > 4,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            dots: lenght > 3,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            dots: lenght > 2,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };
        };

        componentDidMount() {
            store.companies.companyUpdateDelegate = this.update;
        }

        update = () => {
            this.forceUpdate();
        };

        onClick = (index, e) => {
            store.companies.toggleSelected(index);
            setTimeout(() => this.forceUpdate(), 50);
        };

        getLogo = coIndex => {
            if (typeof store.companies.logos[coIndex] !== 'undefined') {
                const logo =
                    store.companies.logos.length > 0 ? store.companies.logos[coIndex].url : '';
                return logo;
            }
            return '';
        };

        render() {
            if (
                !store.companies.data ||
                !store.companies.data.Companies ||
                store.companies.data.Companies.length < 1
            ) {
                return <div className="item">No companies</div>;
            }
            const companyList = store.companies.data.Companies || [];
            return (
                <div>
                    <Slider {...this.getSettings(store.companies.data.Companies.length)}>
                        {companyList.map((detail, i) => (
                            <div key={i}>
                                <CompanyCard
                                    logo={this.getLogo(i)}
                                    onClick={this.onClick}
                                    index={i}
                                    selected={store.companies.selectedIndex === i}
                                    details={companyList[i]}
                                />
                            </div>
                        ))}
                        {/*</Carousel>*/}
                    </Slider>
                </div>
            );
        }
    },
);

export default CompanyCarousel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Company/components/CompanyCarousel.js